import { FirebaseAuthProvider, FirebaseDataProvider, RAFirebaseOptions } from 'react-admin-firebase';
import firebase from 'firebase/compat/app';
import { getFunctions } from 'firebase/functions';
import { getExpoName } from './utils/expoName';

// const projectId = 'conadmin-b9d60';
// const apiKey = 'AIzaSyBsJwyg5mmgY6oJJuhv2wqpuD8qFVfkRcY';
// const messagingSenderId = '705185305518';
// const authDomain = `${projectId}.firebaseapp.com`;
// // this is for web app
// // const appId= "1:705185305518:web:a64ecefeed83aec9e32e3f";
// // const measurementId= "G-Q0JWB7G43H";

// const firebaseConfig = {
//   apiKey,
//   authDomain,
//   databaseURL: `https://${projectId}-default-rtdb.firebaseio.com`,
//   projectId,
//   storageBucket: `${projectId}.appspot.com`,
//   messagingSenderId,
// };

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyAp4Jw-EHBLJrzzEzavtotsoMniUxWdoB8',
  authDomain: 'novilexpo.firebaseapp.com',
  projectId: 'novilexpo',
  storageBucket: 'novilexpo.firebasestorage.app',
  messagingSenderId: '885584901249',
  appId: '1:885584901249:web:00a91d98abfc734c080980',
  measurementId: 'G-EWGKPFR3ZK',
};

const config = firebaseConfig;
// console.log('---- ', window.location.hostname);
const expoName = getExpoName();
console.log('-- ', { expoName });

// const firebaseApp = initializeApp(firebaseConfigBase);
const firebaseApp = firebase.initializeApp(firebaseConfig);

// Initialize Firebase Storage
firebase.storage();

firebase.firestore().settings({
  ignoreUndefinedProperties: true,
});

// https://github.com/benwinding/react-admin-firebase for options
const options: RAFirebaseOptions = {
  logging: false,
  rootRef: `expos/${expoName}`,
  app: firebaseApp,
  // rootRef: 'expos/saha2021',
  // Resources to watch for realtime updates, will implicitly watch all resources by default, if not set.
  // watch: ['posts'],
  renameMetaFields: {
    created_at: 'createdAt', // default: 'createdate'
    created_by: 'createdBy', // default: 'createdby'
    updated_at: 'updatedAt', // default: 'lastupdate'
    updated_by: 'updatedBy', // default: 'updatedby'
  },
};
export const dataProvider = FirebaseDataProvider(config, options);
export const authProvider = FirebaseAuthProvider(config, options);
export const functions = getFunctions(firebaseApp);
